import * as React from 'react';
import { Component } from 'react';
import styles from '../../styles/flyouts/my_company_members/UserEmploymentTerms.scss';
import * as _ from 'lodash';
import { withRouter } from 'react-router';
import autobind from 'autobind-decorator';
import UserEmploymentTermsForm from '../../forms/my_company_members/UserEmploymentTermsForm';
import { __, mapStateToProps, validateForm } from '../../core/utils';
import { setNotification } from '../../redux/actions/general/notification';
import { updateCompanyMember } from '../../redux/actions/table/my_company_members';

@withRouter
@mapStateToProps((state) => ({
  table: state.table['my_company_members'],
}))
class UserEmploymentTerms extends Component {
  @autobind
  _handleSubmit(formData) {
    const { id, user_id } = this.props.data;

    return validateForm(
      updateCompanyMember(id, _.omit(formData, ['id'])).then(() => {
        this.props.readAction(id);

        setNotification(__('meetings.properties.saved'));
      })
    );
  }

  render() {
    const { data } = this.props;

    return (
      <div className={styles.scroller}>
        <UserEmploymentTermsForm
          onSubmit={this._handleSubmit}
          data={data}
          initialValues={{
            ..._.pick(data, [
              'address_book_company_id',
              'vacation_days_base',
              'last_year_vacation_days',
              'used_vacation_days',
              'vacation_days_remaining',
              'minutes_off_base',
              'used_minutes_off',
              'minutes_off_remaining',
              'valid_from',
              'valid_to',
              'type',
              'monday_minutes',
              'tuesday_minutes',
              'wednesday_minutes',
              'thursday_minutes',
              'friday_minutes',
              'saturday_minutes',
              'sunday_minutes',
              'status',
              'created_at',
              'updated_at',
            ]),
          }}
        />
      </div>
    );
  }
}

export default UserEmploymentTerms;
